function errorInfo(error) {
  return {
    status: Number(error?.response?.status) || 0,
    message: error?.response?.data?.message || error?.message || 'Не вдалося зберегти значення.',
  }
}

export function createProductSaveOrchestrator(dependencies) {
  let inFlight = null

  async function executeOperations(productId, operations) {
    const succeeded = []
    const failed = []
    for (const operation of operations) {
      try {
        const response = operation.type === 'delete'
          ? await dependencies.deleteValue(productId, operation.characteristicId)
          : await dependencies.putValue(productId, operation.characteristicId, operation.translations)
        succeeded.push({ operation, response })
      } catch (error) {
        failed.push({ operation, error: errorInfo(error) })
      }
    }
    return { succeeded, failed }
  }

  function save(input) {
    if (inFlight) return inFlight
    inFlight = (async () => {
      const product = input.mode === 'create'
        ? await dependencies.createProduct(input.productPayload)
        : await dependencies.updateProduct(input.productId, input.productPayload)
      const productId = String(product?.id || input.productId || '')
      const operations = await executeOperations(productId, input.operations || [])
      return { productSaved: true, product, productId, ...operations }
    })().finally(() => { inFlight = null })
    return inFlight
  }

  function retryFailed(previousResult, correctedOperations = null) {
    if (inFlight) return inFlight
    inFlight = (async () => {
      const failedIds = new Set(previousResult.failed.map(({ operation }) => String(operation.characteristicId)))
      const requested = correctedOperations || previousResult.failed.map((item) => item.operation)
      const operations = requested.filter((operation) => failedIds.has(String(operation.characteristicId)))
      const retry = await executeOperations(previousResult.productId, operations)
      const attemptedIds = new Set(operations.map((operation) => String(operation.characteristicId)))
      const unattempted = previousResult.failed.filter(({ operation }) => !attemptedIds.has(String(operation.characteristicId)))
      return {
        ...previousResult,
        succeeded: [...previousResult.succeeded, ...retry.succeeded],
        failed: [...unattempted, ...retry.failed],
      }
    })().finally(() => { inFlight = null })
    return inFlight
  }

  return { save, retryFailed, isSubmitting: () => inFlight !== null }
}
